import React, { useEffect, useState } from 'react'
import styles from'./Table2.module.css'
import { ReactComponent as ArrowIcon } from '../../../images/ArrowIcon.svg';
import { CircularProgress } from '@mui/material';

const columns=['Access Code','Status']
interface props{
    data: { [key: string]: any }[];
}
function AccessCodeTable({data}:props) {
    
    const handleSort=(column:string)=>{

    }
    const [loading, setLoading] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  return (
    <div className={`${styles.container} ${styles.expandedContent}`}>
    {/* Table Header */}
    <div
      className='flex items-center justify-between gap-[16px] bg-[#f8f9fa] border-b-[1px] border-b-[#dfe3e8]'
    >
      {columns.map((column, index) => (
        <div
          key={index}
          className='text-[#232321cc] font-medium text-[14px] py-[16px] px-[8px] flex justify-between items-center cursor-pointe whitespace-nowrap '
          onClick={() => handleSort(column)}
        >
            <ArrowIcon
            className={`${styles.arrowIcon} ${
                sortColumn === column
                ? sortDirection === 'asc'
                    ? styles.asc
                    : styles.desc
                : ''
            }`}
            />
            
          {column}
        </div>
      ))}
    </div>

    {/* Table Body */}
    <div className={styles.tableBody}>
      {loading ? (
        <div className="text-center mt-8">
          <CircularProgress />
        </div>
      ) : data?.length > 0 && Array.isArray(data) ? (
        data?.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            {/* Row */}
            <div
              className={styles.accessCodeTableRow}
      style={{ gridTemplateColumns: `repeat(${columns?.length}, 1fr)` }}
          
            >
              {columns.map((column, colIndex) => (
                <div key={colIndex} className={styles.accessCodeTableCell}>
                    {column === 'Status' 
                      ? (row[column] === 'true' ? 'In Use' : row[column] === 'false' ? 'Not Used' : <i>null</i>)
                      : (row[column] || <i>null</i>)
                    }
                </div>
              ))}
            </div>
          </React.Fragment>
        ))
      ) : (
        <div className="text-center mt-8">
          <h1>No Data Found</h1>
        </div>
      )}
    </div>
  </div>
  )
}

export default AccessCodeTable